import type { DriverTableRoute } from "@types_def/models/driver.types";

import { driverTableRouteAttributes } from "@utils/constants/DriverTable/driverTableAttributes";

export function getDriverTableRouteAttributes(driverTable: DriverTableRoute) {
  return (
    driverTableRouteAttributes.find((attribute) => attribute.key === driverTable) ??
    driverTableRouteAttributes[0]
  );
}
